import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '../layouts/DefaultLayout.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    meta: { exemptAuth: true, title: '登录' },
    component: () => import('../components/pages/login.vue')
  },
  {
    path: '/',
    name: 'Home',
    component: Layout,
    redirect: '/home',
    children: [
      {
        path: 'home',
        component: () => import('../components/pages/home.vue'),
        meta: { title: '首页', noCache: true }
      }
    ]
  },
  {
    path: '/business',
    name: '业务办理',
    component: Layout,
    children: [
      {
        path: 'photoInfo',
        name: '拍照信息管理',
        component: () => import('../components/pages/business/photoInfo.vue'),
        meta: { title: '拍照信息管理' }
      },
      {
        path: 'paysInfo',
        name: '缴费信息管理',
        component: () => import('../components/pages/business/paysInfo.vue'),
        meta: { title: '缴费信息管理' }
      },
      {
        path: 'refund',
        name: '退款记录',
        component: () => import('../components/pages/business/refund.vue'),
        meta: { title: '退款记录' }
      }
    ]
  },
  {
    path: '/form',
    name: '统计报表',
    component: Layout,
    children: [
      {
        path: 'day',
        name: '每日统计',
        component: () => import('../components/pages/form/day.vue'),
        meta: { title: '每日统计' }
      },
      {
        path: 'month',
        name: '每月统计',
        component: () => import('../components/pages/form/month.vue'),
        meta: { title: '每月统计' }
      },
      {
        path: 'device',
        name: '设备统计',
        component: () => import('../components/pages/form/device.vue'),
        meta: { title: '设备统计' }
      }
    ]
  },
  {
    path: '/system',
    name: '系统管理',
    component: Layout,
    children: [
      {
        path: 'channel',
        name: '渠道管理',
        component: () => import('../components/pages/system/channel.vue'),
        meta: { title: '渠道管理' }
      },
      {
        path: 'device',
        name: '设备管理',
        component: () => import('../components/pages/system/device.vue'),
        meta: { title: '设备管理' }
      },
      {
        path: 'payconfig',
        name: '支付配置',
        component: () => import('../components/pages/system/payconfig.vue'),
        meta: { title: '支付配置' }
      },
      {
        path: 'users',
        name: '帐户管理',
        component: () => import('../components/pages/system/users.vue'),
        meta: { title: '帐户管理' }
      },
      {
        path: 'role',
        name: '权限管理',
        component: () => import('../components/pages/system/role.vue'),
        meta: { title: '权限管理' }
      },
      {
        path: 'photoType',
        name: '相片规格',
        component: () => import('../components/pages/system/photoType.vue'),
        meta: { title: '相片规格' }
      }
    ]
  },
  {
    path: '/safe',
    name: '安全审计',
    component: Layout,
    children: [
      {
        path: 'operationLog',
        name: '操作日志',
        component: () => import('../components/pages/safe/operationLog.vue'),
        meta: { title: '操作日志' }
      },
      {
        path: 'securityLog',
        name: '安全日志',
        component: () => import('../components/pages/safe/securityLog.vue'),
        meta: { title: '安全日志' }
      },
      {
        path: 'loginLog',
        name: '登录日志',
        component: () => import('../components/pages/safe/loginLog.vue'),
        meta: { title: '登录日志' }
      },
      {
        path: 'ipLock',
        name: '锁定IP',
        component: () => import('../components/pages/safe/ipLock.vue'),
        meta: { title: '锁定IP' }
      }
    ]
  },
  {
    path: '*',
    component: () => import('../components/pages/404.vue')
  }
]

const router = new VueRouter({
  // 发布到 IIS/静态站点后，history 模式刷新会 404；与 Checkup.WEB 一样使用 hash
  mode: 'hash',
  base: '/',
  routes
})

router.beforeEach((to, from, next) => {
  const needAuth = to.matched.some(record => !record.meta.exemptAuth)
  if (needAuth && to.path !== '/login' && sessionStorage['_login'] !== 'true') {
    next({ path: '/login', query: { redirect: to.fullPath } })
  } else {
    next()
  }
})

export default router
